'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.loadScript = void 0;
/**
 * Load script asynchronously
 *
 * @param scriptUrl URL of the script to load
 * @param data data attributes of the script tag
 * @param attributes html attributes of the script tag
 * @returns Promise resolved when script has been loaded
 */
function loadScript(scriptUrl, data, attributes) {
    if (data === void 0) { data = {}; }
    if (attributes === void 0) { attributes = {}; }
    var script = document.createElement('script');
    script.async = true;
    Object.entries(data).forEach(function (_a) {
        var attribute = _a[0], value = _a[1];
        script.dataset[attribute] = value;
    });
    Object.entries(attributes).forEach(function (_a) {
        var attribute = _a[0], value = _a[1];
        script.setAttribute(attribute, value);
    });
    return new Promise(function (resolve, reject) {
        script.onload = function () {
            resolve();
        };
        script.onerror = function () {
            reject();
        };
        script.src = scriptUrl;
        document.head.appendChild(script);
    });
}
exports.loadScript = loadScript;
